import http from "./HttpService";

var endpoint = `/reporting/analytics/stemi/olympiads/`;
var eventendpoint = `/reporting/analytics/events/`;
var roundpoint = `/lookup/stemi/`;
var uploadendpoint = `/stemi/upload/`;

const headers = {};

const getOlympiadSectorProvince = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}sector/province/${year}/${roundId}`);
    return response;
};

const getOlympiadSectorGrade = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}sector/grade/${year}/${roundId}`);
    return response;
};

const getOlympiadSectorGender = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}sector/gender/${year}/${roundId}`);
    return response;
};

const getParticipantSector = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/sector/${year}/${roundId}`);
  return response;
};

const getOlympiadProvince = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}province?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
  return response;
};

const getOlympiadDistrict = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}district?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
  return response;
};

const getParticipantSchoolType = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/school-type?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
    return response;
};

const getParticipantRace = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/race?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
    return response;
};

const getParticipantProvince = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/province?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
  return response;
};

const getParticipantGender = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/gender?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
    return response;
};

const getParticipantDistrict = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/district?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
  return response;
};

const getParticipantDisability = async ({year, roundId, competition, sector=sector}) => {
  const response = await http.get(`${endpoint}participant/disability?year=${year}&competition=${competition}&sector=${sector}&round=${roundId}`);
    return response;
};

const getStemiRounds = async () => {
  const response = await http.get(`${roundpoint}rounds`);
    return response;
};

const getYearRange = async () => {
  const response = await http.get(`${endpoint}year-range`); 
  return response;
};


const getStemiOlympiadNames = async () => {
  const response = await http.get(`${roundpoint}olympiad-names`);
  return response;
};


const getStemiSectors = async () => {
  const response = await http.get(`${roundpoint}sectors`);
  return response;
};

export default {
  getOlympiadSectorProvince,
  getOlympiadSectorGrade,
  getOlympiadSectorGender,
  getOlympiadProvince,
  getOlympiadDistrict,
  getParticipantSector,
  getParticipantSchoolType,
  getParticipantRace,
  getParticipantProvince,
  getParticipantGender,
  getParticipantDistrict,
  getParticipantDisability,
  getYearRange,
  getStemiRounds,
  getStemiOlympiadNames,
  getStemiSectors
};
